import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { PdfViewer } from 'src/components/pdf-viewer';
import { routes } from 'src/constants/routes';
import { useLicencePdfData } from 'src/lib/hooks/use-get-licence-pdf-data';
import { Building } from 'src/shared/types/building';

export const AgreementContent: FC<{ building: Building }> = ({ building }) => {
    const { data, isPending, isError } = useLicencePdfData(building);
    const navigate = useNavigate();

    if (isError) {
        navigate(routes.failure.index);
    }

    return <PdfViewer file={data} isLoading={isPending} name="licence-agreement" />;
};
